import React, { useContext, useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { List } from './List';
import { AuthContext } from 'contexts/AuthContext';
import { getGeneralSettings } from "utils/api";

export const AdminSettings = () => {
    const { handleError } = useContext(AuthContext);

    const [settings, setSettings] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchSettings = async () => {
        setIsLoading(true);

        try {
            const res = await getGeneralSettings();

            const generalSettings = res?.general_settings ? res.general_settings.filter((item) => item.name !== 'OPENAI_API_KEY') : [];
            setSettings(generalSettings);
        } catch (err) {
            handleError(err);
        }

        setIsLoading(false);
    };

    useEffect(() => {
        fetchSettings();
    }, []);

    return (
        <div className="view view--mobile-full">
            <div className="animated fadeIn">
                <Row>
                    <Col xs="12">
                        <Card>
                            <CardHeader>
                                <div className="flex-space-between">
                                    <h1>Settings</h1>
                                </div>
                            </CardHeader>
                            <CardBody>
                                <List settings={settings} isLoading={isLoading} refreshSettings={fetchSettings}/>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    );
};
